import React, { Component } from "react";
import { FiChevronRight } from "react-icons/fi";
import { Redirect } from "react-router-dom";

class SimpleHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
    };
  }

  render() {
    if (this.state.redirect) {
      return <Redirect push to={this.props.path} />;
    }
    return (
      <header
        className="row mx-0 px-4 py-3 shadow-sm position-fixed bg-white"
        style={{ top: "0", right: "0", left: "0", zIndex: "1" }}
      >
        <div className="col-auto px-0 align-self-center">
          <FiChevronRight
            onClick={() =>
              this.props.path
                ? this.setState({ redirect: true })
                : window.history.length > 1
                ? window.history.back()
                : this.setState({ redirect: true })
            }
            className="ms-2"
            size="30"
          />
        </div>
        <div className="col align-self-center text-center px-0">
          <h1 className="fs-5 fw-bold mb-0">{this.props.text}</h1>
        </div>
      </header>
    );
  }
}

export default SimpleHeader;
